import React, { useState, useEffect, useRef } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-toastify/dist/ReactToastify.css'
import { Formik, Form } from "formik"
import Yup from '../../../../util/Validacoes'
import { mostrarToast } from '../../../../components/Toasts'
import { useParams } from "react-router-dom"
import { get, salvar } from '../../../../util/AcessoApi'
import { HeaderCadastro } from '../../../../components/Headers'
import { Link, useHistory } from 'react-router-dom'
import { InputPadrao, InputDatePicker, TextArea, InputValor } from '../../../../components/Inputs'
import { InputFornecedor, InputProduto } from '../../../../components/InputsAutoComplete'
import InputArquivoS3 from '../../../../components/InputArquivoS3'
import { BotaoPadrao } from '../../../../components/Botoes'
import { mensagens } from '../../../../util/Utilitarios'
import '../../../../assets/css/icones/iconsmind/style.css'
import Atalho from '../../../../util/Atalho'
import { ModalDuasOpcoes } from '../../../../components/Modais'
import { MODULO } from '../../../../util/Enums'
import { toText } from '../../../../util/FuncoesComuns'

export const Entrada = props => {
    let { id } = useParams()
    const history = useHistory();
    const idProduto = (history.location.state && history.location.state.id_produto) ? history.location.state.id_produto : null

    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [errosValidacao, setErrosValidacao] = useState([]); // string[]
    const [showValidacao, setShowValidacao] = useState(false);
    const [dataArquivos, setDataArquivos] = useState(null)
    const refInput = useRef(null)
    const [limparArquivos, setLimparArquivos] = useState(false)

    useEffect(() => {
        if (id)
            Promise.resolve(get(`/estoque/produtoentradasaida/${id}`)).then(val => {
                if (!val)
                    props.history.push('/estoque/produtoentradasaida/consulta')

                let valorInicial = { ...val }
                delete valorInicial.arquivo
                setDataArquivos(val.arquivo)
                setValoresIniciais(valorInicial)
            })
        else {
            setDataArquivos([])
            let valorInicial = { produto: null, data: null, quantidade: null, responsavel: '', lote: '', nota_fiscal: '', custo_unitario: '', custo_total: '', validade: '', cliente: null, observacao: '' }

            if (idProduto)
                Promise.resolve(get(`/estoque/produto/${idProduto}`)).then(val => {
                    if (val.id)
                        valorInicial.produto = { value: val.id, codigo_barras: val.codigo_barras, label: val.id + ' - ' + val.descricao }

                    setValoresIniciais(valorInicial)
                    document.getElementById("data").focus()
                })
            else
                setValoresIniciais(valorInicial)
        }
    }, [id])

    const manter = ['produto', 'data', 'responsavel']

    const validar = (values, propsFormik) => {
        setSalvando(true)
        Promise.resolve(get(`/estoque/validarprodutoentrada`, values, true)).then(val => {
            const lista = Array.isArray(val) ? val : (val?.data ?? val?.result ?? []);
            const erros = (Array.isArray(lista) ? lista : [lista])
                .map((x) => (typeof x === "string" ? x : JSON.stringify(x)))
                .filter(Boolean);

            if (erros.length) {
                setErrosValidacao(erros);
                setShowValidacao(true);
            } else {
                const newFormik = { ...propsFormik, values: { ...values } };
                submit(newFormik);
            }
        });
    }

    const submit = propsFormik => {
        setSalvando(true)
        setShowValidacao(false)
        propsFormik.values.arquivo = dataArquivos

        salvar(propsFormik.values, '/estoque/produtoentrada',
            _ => {
                mostrarToast('sucesso', mensagens.sucesso)

                if (salvarENovo) {
                    setLimparArquivos(true)
                    setDataArquivos([])
                    propsFormik.resetForm({})
                    manter.forEach(x => propsFormik.setFieldValue(x, propsFormik.values[x]))
                    setSalvando(false)
                    setSalvarENovo(false)
                    refInput.current.focus()
                    setLimparArquivos(false)
                }
                else
                    props.history.push('/estoque/produtoentradasaida/consulta')
            }, _ => setSalvando(false))
    }

    const somaCustoTotal = (propsFormik) => {

        let quantidade = propsFormik.values.quantidade
        let custoUnitario = propsFormik.values.custo_unitario
        if (quantidade && custoUnitario) {
            let soma = quantidade * custoUnitario
            propsFormik.setFieldValue('custo_total', parseFloat(soma))
        }
    }

    return (<Formik enableReinitialize={true} onSubmit={validar} initialValues={valoresIniciais}
        validationSchema={Yup.object({
            produto: Yup.string().nullable().required(),
            data: Yup.string().nullable().required(),
            quantidade: Yup.string().nullable().required(),
            resposanvel: Yup.string().nullable(),
            lote: Yup.string().nullable(),
            custo_unitario: Yup.string().nullable(),
            custo_total: Yup.string().nullable(),
            validade: Yup.string().nullable(),
            cliente: Yup.string().nullable(),
            observacao: Yup.string().max(200).nullable(),
        })}>
        {({ handleChange, ...propsFormik }) => (<Form>
            <div className={props.modal ? '' : 'card mb-20'}>
                <div className={props.modal ? '' : 'card-body'}>
                    <div className='row'>
                        <InputPadrao label="Id" name="id" type="hidden" placeholder="Id" />
                        <InputProduto autoFocus openMenuOnFocus={true} label="Código/Produto" name="produto" placeholder="Código/Produto" propsFormik={propsFormik} obrigatorio tamanho='col-lg-3 col-md-6' salvarENovo={salvarENovo} />
                        <InputDatePicker targetFocus={refInput} label="Data Entrada" name="data" id="data" type="text" setarValor={value => propsFormik.setFieldValue('data', value)} obrigatorio={true} tamanho='col-lg-3 col-md-6' placeholder="Data Entrada" classeTooltip={props.modal && 'tooltip-input-modal'} />
                        <InputPadrao label="Quantidade" onBlur={() => somaCustoTotal(propsFormik)} name="quantidade" type="number" placeholder="Quantidade" tamanho="col-lg-2 col-md-4" obrigatorio />
                        <InputFornecedor label="Fornecedor" name="responsavel" placeholder="Fornecedor" propsFormik={propsFormik} tamanho='col-lg-4' salvarENovo={salvarENovo} />
                        <InputPadrao label="N° Serie/Lote" name="lote" type="text" placeholder="N° Serie/Lote" tamanho="col-lg-2" />
                        <InputPadrao label="Nota Fiscal/Contrato" name="nota_fiscal" type="text" placeholder="Nota Fiscal/Contrato" tamanho="col-lg-2" />
                        <InputValor label='Custo Unitário' onBlur={() => somaCustoTotal(propsFormik)} name='custo_unitario' classDiv='col-lg-2' propsFormik={propsFormik} max={100000000} {...props} />
                        <InputValor label='Custo Total' name='custo_total' classDiv='col-lg-2' propsFormik={propsFormik} max={100000000} {...props} />
                        <InputDatePicker label="Validade" name="validade" type="text" setarValor={value => propsFormik.setFieldValue('validade', value)} tamanho='col-lg-3 col-md-6' placeholder="Validade" classeTooltip={props.modal && 'tooltip-input-modal'} />
                        <InputFornecedor label="TAG (Cliente)" name="cliente" placeholder="TAG (Cliente)" propsFormik={propsFormik} tamanho='col-lg-4' salvarENovo={salvarENovo} />
                        <TextArea label='Observação' name='observacao' type='text' placeholder='Observação' tamanho='col-lg-6' />
                        {dataArquivos != null ?
                            <InputArquivoS3
                                label='Arquivos'
                                name='arquivo'
                                placeholder='Arquivos'
                                tamanho='col-lg-12'
                                diretorioS3='produtoentrada/DDMMYYYY/'
                                modulo={MODULO["/estoque/produtoentradasaida"]}
                                tamanhoMinimo={0}
                                tamanhoMaximoEmMB={300}

                                setDataArquivos={setDataArquivos}
                                dataArquivos={dataArquivos != null ? dataArquivos : []}
                                setIsSubmit={dataArquivos.length > 0 ? setSalvando : () => { }}
                                // setDataArquivos={setDataArquivos}
                                // dataArquivos={dataArquivos != null ? dataArquivos : []}
                                // setIsSubmit={setSalvando}
                                limparCampos={limparArquivos}
                            /> : <></>}
                        <Atalho formik={propsFormik} salvando={salvando} setSalvareNovo={setSalvarENovo} salvarENovo={true} />
                    </div>
                </div>
            </div>
            <div className='separator mt-40 mb-5'></div>
            <div className='direita container-botoes mb-3 group-salvar-novo'>
                <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => setSalvarENovo(false)} idTooltip={'salvar'} />
                {!id && <BotaoPadrao texto='Salvar e Novo' disabled={salvando} click={_ => setSalvarENovo(true)} idTooltip={'salvarENovo'} />}
            </div>
            <ModalDuasOpcoes
                showModal={showValidacao}
                setShowModal={setShowValidacao}
                funcaoOpcao2={_ => { submit(propsFormik); setShowValidacao(false) }}
                funcaoOpcao1={_ => { setSalvando(false); setShowValidacao(false) }}
                esconderFechar
                mensagem={''}
                textoOpcao1="Cancelar"
                classeOpcao1="btn-sm btn-primary-modal simples"
                textoOpcao2="Continuar"
            >
                <>
                    {errosValidacao.map((t, i) => (
                        <div key={i} style={{ marginBottom: 12, whiteSpace: "pre-line" }}>
                            {t}
                        </div>
                    ))}
                    <b>Deseja Continuar?</b>
                </>
            </ModalDuasOpcoes>
        </Form>)}
    </Formik>)
}

export default props => {
    const links = [
        () => <Link to={'/dashboard'}>Dashboard</Link>,
        () => <Link to={'#'}>Estoque</Link>,
        () => <Link className="link-active" to={'/estoque/produtoentradasaida/consulta'}>Entrada/Saída de Produto</Link>,
    ]
    return (<>
        <HeaderCadastro titulo={"Cadastro Entrada de Produto"} link={links} />
        <Entrada {...props} />
    </>)
}